export const LOCALES = {
  EN: "en", // 英语（默认语言）
  ZHTW: "zh-tw", // 中文繁体（使用繁体汉字）
} as const;

export type Locale = (typeof LOCALES)[keyof typeof LOCALES];

/**
 * 检查是否为有效的语言代码
 * @param locale 语言代码
 * @returns 是否为有效语言
 */
export function isValidLocale(locale: string): locale is Locale {
  return Object.values(LOCALES).includes(locale as Locale);
}
